// BAG file format
// see https://support.hdfgroup.org/HDF5/doc/H5.format.html
// see http://www.opennavsurf.org/papers/BAG_FSD_Release_1.5.1.pdf
// keyword Format Signature

const expected = [ 0x89, 'H', 'D', 'F', '\r', '\n', 0x1a, '\n' ];

const get_char = (value) => {
	if( typeof value === "string" ) {
		return value.charCodeAt(0);
	} else {
		return value;
	}	
}

const parseBagHeader = (buffer) => {
	const dataView = new DataView(buffer);
	let validBag = true;
	
	// check if file header matched
	for(let i = 0; i < expected.length && validBag; i++) {
		const current = dataView.getUint8(i);
		const expectedValue = get_char(expected[i]);
		validBag = validBag && current === expectedValue;
	}			

    return validBag;
};

const bag = async (reader) => {
	const buffer = await reader.read(0, 512);
	return parseBagHeader( buffer );
}

export {
	bag
}